export const /** @type {?} */ GroupTemplates = {
  defaultTemplate: {
    property: {
      display: true,
      disable: false,
      label: '',
      minSelected: 1,
      maxSelected: 1,
      allSelected: false
    }
  }
}
